import React from 'react';
import {PortableText} from '@portabletext/react';
import clsx from 'clsx';
import {Link} from '../Link';

interface Props {
  richtext: any;
  className?: string;
}

const SanityRichText: React.FC<Props> = ({richtext, className}) => {
  return (
    <PortableText
      value={richtext}
      components={{
        marks: {
          annotationLinkInternal: ({children, value}) => {
            return <Link to={value.slug}>{children}</Link>;
          },
          annotationLinkExternal: ({children, value}) => {
            return (
              <a
                href={value.url}
                target={value.newWindow ? '_blank' : '_self'}
                rel="noopener noreferrer"
                className='underline'
              >
                {children}
              </a>
            );
          },
        },
        block: {
          // image: ({children, value}) => {
          //   console.log(value);
          //   return <></>;
          // },
          h1: ({children}) => {
            return (
              <h1 className="mt-10 mb-4 text-center text-xl font-bold">
                {children}
              </h1>
            );
          },
          h2: ({children}) => {
            return <h2 className="mt-10 mb-4 text-xl font-bold">{children}</h2>;
          },
          h3: ({children}) => {
            return (
              <h3 className="mt-8 mb-3 text-center text-lg font-semibold">
                {children}
              </h3>
            );
          },
          h4: ({children}) => {
            return <h4 className="mt-8 mb-3 text-lg font-semibold">{children}</h4>;
          },
          h5: ({children}) => {
            return <h5 className="text-md">{children}</h5>;
          },
          h6: ({children}) => {
            return <h6 className="text-md">{children}</h6>;
          },
          normal: ({children}) => {
            return (
              <p className="min-h-[25px] text-md font-normal leading-relaxed">
                {children}
              </p>
            );
          },
        },
        list: {
          // Ex. 1: customizing common list types
          bullet: ({children}) => <ul className="list-disc my-2">{children}</ul>,
          number: ({children}) => <ol className="list-decimal my-2">{children}</ol>,
        },
        listItem: {
          // Ex. 1: customizing common list types
          bullet: ({children}) => <li className="list-inside">{children}</li>,
          number: ({children}) => <li className="list-inside">{children}</li>,
        },
      }}
    />
  );
};

export default SanityRichText;
